var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("SVG Map")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('svg-map',{attrs:{"map-settings":{
                mapHeight: '500px', 
                activeStateColor: '#ce2a23', 
                inactiveStateColor: '#6f859a', 
                hiddenStateAbbrev: ['MD', 'RI', 'CT', 'MA', 'NH', 'DC', 'DE', 'NJ', 'VT'], 
                showAccessibleStateSelector: true, 
                screenReaderMapTitle: 'CPR In Schools Legislation Map', 
                selectorButtonLabel: 'Select',
                blankSelectorOptionLabel: 'Select A State'},"map-data":[
                {
                    id: 'US-AL',
                    value: '1',
                    line1: 'CPR training required for high school graduation.',
                    line2: 'Began in 2017-2018 school year.',
                    line3: 'Click on state to read law in full. ',
                    url: 'https://www.alabama.gov/'
                },
                {
                    id: 'US-AK',
                    value: '0',
                    line1: 'ALASKA CPR training required for high school graduation.',
                    line2: 'Began in 2017-2018 school year.',
                    line3: 'Click on state to read law in full. ',
                    url: 'https://www.alaska.gov/'
                },
                {
                    id: 'US-AZ',
                    value: '1',
                    line1: 'This is line 1',
                    line2: 'This is line 2',
                    line3: 'This is line 3',
                    url: 'https://az.gov/'
                },
                {
                    id: 'US-AR',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-CA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-CO',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-CT',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-DC',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-DE',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-FL',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-GA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-HI',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-ID',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-IL',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-IN',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-IA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-KS',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-KY',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-LA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-ME',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MD',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MA',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MI',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MN',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MS',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MO',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MT',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NE',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NV',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NH',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NJ',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NM',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NY',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NC',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-ND',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-OH',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-OK',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-OR',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-PA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-RI',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-SC',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-SD',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-TN',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-TX',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-UT',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-VT',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-VA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-WA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-WV',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-WI',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-WY',
                    value: '0',
                    url: 'http://www.google.com'
                }
            ]}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd2f9326","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/pages/components/svg-map.vue
// module id = 1472
// module chunks = 0